import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SwiperFixService {
  swiper: {
    containerRef?: HTMLElement,
    containerClassList?: string[],
    wrapperRef?: HTMLElement,
    wrapperClassList?: string[],
  } = {}

  defAnimation = {
    transform: "translate3d(-1707px, 0px, 0px)",
    "transition-duration": "0ms"
  }

  constructor() { }

  fullscreenFix(isMaximizing: boolean){
    if (isMaximizing) {
      let wrapper = (document.querySelector(".swiper-wrapper") as HTMLElement);
      if(wrapper == null) return;
      this.swiper = {};
      this.swiper.containerRef = wrapper.parentElement;
      this.swiper.containerClassList = Array.from(wrapper.parentElement.classList);
      this.swiper.wrapperRef = wrapper;
      this.swiper.wrapperClassList = Array.from(wrapper.classList);
      this.removeClasses();
    } else {
      if(this.swiper.wrapperRef != undefined) this.addClasses();
    }
  }

  removeClasses(){
    this.swiper.containerRef.classList.remove(...this.swiper.containerClassList);
    this.swiper.wrapperRef.classList.remove(...this.swiper.wrapperClassList);
    Object.keys(this.defAnimation).forEach(key => {
      if(key != 'transform') this.defAnimation[key] = this.swiper.wrapperRef.style[key];
      else{
        this.defAnimation[key] = `translate3d(${(document.querySelector('.swiper-slide') as HTMLElement).offsetWidth}, 0px, 0px)`;
      }
      this.swiper.wrapperRef.style[key] = '';
    });
  }

  addClasses(){
    this.swiper.containerRef.classList.add(...this.swiper.containerClassList);
    this.swiper.wrapperRef.classList.add(...this.swiper.wrapperClassList);
    
    Object.keys(this.defAnimation).forEach(key => {
      this.swiper.wrapperRef.style[key] = this.defAnimation[key];
    });
  }
}
